var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeMoreThanFourHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#fe4d01",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.702 7.688L12 12 6.3 7.725a.75.75 0 0 1-.3-.6V3.75A.75.75 0 0 1 6.75 3h10.5a.75.75 0 0 1 .75.75v3.341a.75.75 0 0 1-.298.596zM6 16.875v3.375a.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75v-3.341a.75.75 0 0 0-.298-.598L12 12l-5.7 4.275a.75.75 0 0 0-.3.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.091V3.75a1.5 1.5 0 0 0-1.5-1.5H6.75a1.5 1.5 0 0 0-1.5 1.5v3.375c.001.233.055.462.159.67s.255.389.441.53L10.75 12l-4.9 3.675c-.186.14-.337.321-.441.529s-.159.438-.159.671v3.375a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5v-3.341c0-.232-.055-.461-.158-.668s-.253-.389-.437-.529L13.244 12l4.911-3.712a1.51 1.51 0 0 0 .438-.529c.103-.208.157-.436.158-.668zm-1.5 13.159H6.75v-3.375L12 12.938l5.25 3.97v3.342zm0-13.159L12 11.063 6.75 7.125V3.75h10.5v3.341z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeMoreThanFourHours);
export default __webpack_public_path__ + "static/media/timeMoreThanFourHours.6d7ba3b9630b15d40a757742e9c7c6f8.svg";
export { ForwardRef as ReactComponent };